import { BigFooter } from "./BigFooter";
import { MobileFooter } from "./MobileFooter";

export const Footer = () => {
    return window.innerWidth > 800 ? <BigFooter /> : <MobileFooter />;
};
